import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "panel-content" }
const _hoisted_2 = { class: "store-header" }
const _hoisted_3 = { class: "small" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, { cols: "12" }, {
          default: _withCtx(() => [
            _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.storeName), 1),
            _createElementVNode("p", _hoisted_3, [
              _createTextVNode(_toDisplayString(_ctx.store?.address), 1),
              _hoisted_4,
              _createTextVNode(" " + _toDisplayString(_ctx.store?.city) + ", " + _toDisplayString(_ctx.store?.state) + " " + _toDisplayString(_ctx.store?.zip), 1)
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}